import RestClient from '@/api/api';

class DocumentsAPI extends RestClient {
  async getDocuments() {
    return this._get('/documents');
  }

  async getDocument(id) {
    return this._get(`/documents/${id}`);
  }

  async uploadDocument(formData) {
    const response = await this.makeRequest('post', '/documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return this.getResponseData(response);
  }

  async deleteDocument(id) {
    return this._delete(`/documents/${id}`);
  }
}

export default new DocumentsAPI();
